import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapDateTime = React.lazy(function () {
    return import('../../bootstrap-components/components/BTDataSharingComponent');
});
var bootStrapDateTime = function (props) {
    return (React.createElement(BootStrapDateTime, __assign({}, props)));
};
var DataSharingComponent = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapDateTime(props);
            break;
        default:
            componentToDisplay = bootStrapDateTime(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
DataSharingComponent.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
};
export default DataSharingComponent;
//# sourceMappingURL=DataSharingComponent.js.map